import { Coord } from "../../../../../../../../../src/types/Interface";
import getCoord from "../../../../../../../../../src/utils/coord/getCoord";
import getDistanceBtwPoints from "../../../../../../../../../src/utils/getDistanceBtwPoints";


export default function getAnimatedEndCoord(shapeCoord: Coord, pivotCoord: Coord, radian: number) {
  const distance = getDistanceBtwPoints(shapeCoord, pivotCoord);
  return getCoord(pivotCoord, distance, radian);
}
